module.exports = __webpack_public_path__ + "img/esports_demo-1-400x300.e5fe4210.jpg";